export default __webpack_public_path__ + "static/media/brand7-black.7b018730.svg";